import { LocationMembership } from '../models'
import store from '../store'

async function fetchAndStoreSettings(locationId: string): Promise<void> {
  try {
    await Promise.all([
      fetchAndStoreClientPortalInfo(locationId),
      fetchAndStoreDomainInfo(locationId),
      fetchAndStoreBuilderSettings(locationId),
    ])
  } catch (error) {
    console.error('Error fetching membership settings')
    console.error(error)
  }
}

async function fetchAndStoreClientPortalInfo(locationId: string): Promise<void> {
  return LocationMembership.getPortalSettingsByLocationId(locationId)
    .then(clientPortalInfo => {
      store.commit('membership/setClientPortalInfo', clientPortalInfo)
    })
    .catch(error => {
      console.error('Error fetching client portal details')
      console.error(error)
    })
}

async function fetchAndStoreDomainInfo(locationId: string): Promise<void> {
  return Promise.all([
    LocationMembership.getDomainInfoByLocationId(locationId, { type: 'custom' }),
    LocationMembership.getDomainInfoByLocationId(locationId, { type: 'subdomain' }),
    LocationMembership.getSiteInfoByLocationId(locationId),
  ])
    .then(([legacyCustomDomainInfo, legacySubDomainInfo, siteInfo]) => {
      const domainInfo = { legacyCustomDomainInfo, legacySubDomainInfo, siteInfo }
      store.commit('membership/setDomainInfo', domainInfo)
    })
    .catch(error => {
      console.error('Error fetching domain info')
      console.error(error)
    })
}

async function fetchAndStoreBuilderSettings(locationId: string, forceReload = false): Promise<void> {
  return LocationMembership.getBuilderSettingsByLocationId(locationId)
    .then(builderSettings => {
      store.commit('membership/setBuilderSettings', builderSettings)
    })
    .catch(error => {
      console.error('Error fetching builder settings')
      console.error(error)
    })
}

export { fetchAndStoreSettings, fetchAndStoreDomainInfo, fetchAndStoreClientPortalInfo, fetchAndStoreBuilderSettings }
